import { t } from "i18next";

export const dataRadios = [
  { id: 0, value: "0", title: t("common:has_not") },
  { id: 1, value: "1", title: t("common:has") },
];
